<div class="alert-overlay" *ngIf="visible">
  <div class="alert-card">
    <div class="alert-header" [ngStyle]="{'background-color': alertbgcolor}">
      <h4 [ngStyle]="{'color': alerttextcolor}">{{ title }}</h4>
    </div>
    <div class="alert-body">
      <div class="alert-message-container">
        <p class="alert-message">{{ message }}</p>
      </div>
      <div class="button-container">
        <button class="btn btn-close" (click)="closeAlert()">Close</button>
      </div>
    </div>
  </div>
</div>
